var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cyzs-image",class:_vm.wrapClass,style:(_vm.wrapStyle)},[_c('img',{attrs:{"src":_vm.displayImage.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }